import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const StyledAccordion = styled(Accordion)`
  background-color: transparent;
  .MuiAccordionSummary-root {
    border-bottom: 1px solid #ebecf0;
    min-height: 2rem;
    font-size: 1.25rem;
    font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
    font-weight: 700;
    color: #002740;
    line-height: 1.35;

    .MuiAccordionSummary-content {
      margin: 0.25rem 0 0.25rem 0.25rem;
    }
    .MuiAccordionSummary-expandIcon {
      margin: 0.25rem 0 0.25rem 0;
    }
    .MuiSvgIcon-root {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
  .MuiAccordionDetails-root {
    display: block;
  }
`;

interface IFormAccordionProps {
  summary: React.ReactNode;
  details: React.ReactNode;
}

const FormAccordion = (props: IFormAccordionProps) => {
  const { summary, details } = props;
  return (
    <StyledAccordion
      elevation={0}
      defaultExpanded
      className="CMuiResponsiveDrawerBox"
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {summary}
      </AccordionSummary>
      <AccordionDetails>{details}</AccordionDetails>
    </StyledAccordion>
  );
};

export default FormAccordion;
